//setAnalytics() musi byt definovano v sablone

CookieConsent.run({
	onConsent: setAnalytics,
	guiOptions: {
		consentModal: {
			layout: "box wide",
			position: "bottom center",
			equalWeightButtons: false,
			flipButtons: false
		},
		preferencesModal: {
			layout: "box wide",
			position: "bottom center",
			equalWeightButtons: true,
			flipButtons: false
		}
	},
	categories: {
		necessary: {
			enabled: true,  // this category is enabled by default
			readOnly: true  // this category cannot be disabled
		},
		analytics: {},
		targeting: {}
	},

	language: {
		default: 'cs',
		translations: {
			cs: {
				consentModal: {
					title: 'Používáme cookies!',
					description: 'Tyto stránky používají základní cookies, aby bylo možné s nimi pracovat. Kromě toho používáme sledovací cookies, které nám říkají, jak se stránkami pracujete. Sledovací cookies budou nastaveny pouze s vaším souhlasem.',
					acceptAllBtn: 'Přijmout vše',
					acceptNecessaryBtn: 'Odmítnout',
					showPreferencesBtn: 'Chci si vybrat'
				},
				preferencesModal: {
					title: 'Předvolby cookies',
					acceptAllBtn: 'Přijmout vše',
					acceptNecessaryBtn: 'Odmítnout vše',
					savePreferencesBtn: 'Přimout moje volby',
					closeIconLabel: 'Zavřít',
					sections: [
						{
							title: 'Použití cookies',
							description: 'Používáme cookies pro zajištění základních funkcí stránek a pro zlepšení vašeho uživatelského zážitku.'
						},
						{
							title: 'Nezbytné cookies',
							description: 'Tyto soubory cookie jsou nezbytné pro správné fungování těchto webových stránek. Bez těchto souborů cookie by webové stránky nefungovaly správně.',

							//this field will generate a toggle linked to the 'necessary' category
							linkedCategory: 'necessary'
						},
						{
							title: 'Výkonnostní a analytické soubory cookie',
							description: 'Tyto soubory cookie umožňují webové stránce zapamatovat si volby, které jste provedli v minulosti.',
							linkedCategory: 'analytics'
						},
						{
							title: 'Soubory cookie pro reklamu a cílení',
							description: 'Tyto soubory cookie shromažďují informace o tom, jak webové stránky používáte, které stránky jste navštívili a na které odkazy jste klikli. Všechny údaje jsou anonymizované a nelze je použít k vaší identifikaci.',
							linkedCategory: 'targeting'
						}
					]
				}
			}
		}
	}
});

let analyticsHeaderSet = false;

//pokud jeste nebylo nastaveno, nebo neni consent na analytics, tak se nastavi
if(!CookieConsent.acceptedCategory('analytics')) {
	document.addEventListener('DOMContentLoaded', function() {
		setAnalytics();
	});
}